// AUTO-GENERATED by scripts/build-nav.mjs — do not edit by hand.
// Run `node scripts/build-nav.mjs` (or `npm run build-nav`) to regenerate.
import type { Navigation } from "zudoku";

export const ecommerceApiNav: Navigation = [
  {
    "type": "category",
    "label": "Data",
    "collapsible": true,
    "collapsed": false,
    "items": [
      {
        "type": "link",
        "to": "/api/data-1-products",
        "label": "Products"
      },
      {
        "type": "link",
        "to": "/api/data-4-sellers",
        "label": "Sellers"
      },
      {
        "type": "link",
        "to": "/api/data-2-creators",
        "label": "Creators"
      },
      {
        "type": "link",
        "to": "/api/data-3-videos",
        "label": "Videos"
      },
      {
        "type": "link",
        "to": "/api/data-6-lives",
        "label": "Lives"
      },
      {
        "type": "link",
        "to": "/api/data-5-ads-creatives",
        "label": "Ads & Creatives"
      }
    ]
  },
  {
    "type": "category",
    "label": "Content",
    "collapsible": true,
    "collapsed": false,
    "items": [
      {
        "type": "link",
        "to": "/api/content-1-ai-video",
        "label": "AI Video"
      },
      {
        "type": "link",
        "to": "/api/content-2-ai-image",
        "label": "AI Image"
      },
      {
        "type": "link",
        "to": "/api/content-3-ai-copywriting",
        "label": "AI Copywriting"
      },
      {
        "type": "link",
        "to": "/api/content-4-ai-analysis",
        "label": "AI Analysis"
      }
    ]
  },
  {
    "type": "category",
    "label": "Social",
    "collapsible": true,
    "collapsed": false,
    "items": [
      {
        "type": "link",
        "to": "/api/social-1-account-management",
        "label": "Account Management"
      },
      {
        "type": "link",
        "to": "/api/social-2-video-publishing",
        "label": "Video Publishing"
      },
      {
        "type": "link",
        "to": "/api/social-3-video-management",
        "label": "Video Management"
      },
      {
        "type": "link",
        "to": "/api/social-4-comment-management",
        "label": "Comment Management"
      },
      {
        "type": "link",
        "to": "/api/social-5-analytics",
        "label": "Analytics"
      },
      {
        "type": "link",
        "to": "/api/social-6-creation-tools",
        "label": "Creation Tools"
      },
      {
        "type": "link",
        "to": "/api/social-7-tiktok-shop",
        "label": "TikTok Shop"
      },
      {
        "type": "link",
        "to": "/api/social-8-direct-messages",
        "label": "Direct Messages"
      },
      {
        "type": "link",
        "to": "/api/social-9-seller-analytics",
        "label": "Seller Analytics"
      }
    ]
  },
  {
    "type": "category",
    "label": "Ads",
    "collapsible": true,
    "collapsed": false,
    "items": [
      {
        "type": "link",
        "to": "/api/ads-1-accounts",
        "label": "Accounts"
      },
      {
        "type": "link",
        "to": "/api/ads-2-delivery",
        "label": "Delivery"
      },
      {
        "type": "link",
        "to": "/api/ads-3-gmv-max",
        "label": "GMV MAX"
      }
    ]
  },
  {
    "type": "category",
    "label": "Trenz Agent",
    "collapsible": true,
    "collapsed": false,
    "items": [
      {
        "type": "link",
        "to": "/api/trenz-agent-1-chat",
        "label": "Chat"
      },
      {
        "type": "link",
        "to": "/api/trenz-agent-2-sessions-reports",
        "label": "Sessions & Reports"
      }
    ]
  },
  {
    "type": "link",
    "to": "/api/account",
    "label": "Account"
  },
  {
    "type": "link",
    "to": "/api/async-tasks",
    "label": "Async Tasks"
  },
  {
    "type": "link",
    "to": "/api/file-upload",
    "label": "File Upload"
  }
];

export const llmApiNav: Navigation = [
  {
    "type": "link",
    "to": "/llm-api/对话补全",
    "label": "对话补全"
  },
  {
    "type": "link",
    "to": "/llm-api/图片生成",
    "label": "图片生成"
  },
  {
    "type": "link",
    "to": "/llm-api/视频生成",
    "label": "视频生成"
  },
  {
    "type": "link",
    "to": "/llm-api/异步任务",
    "label": "异步任务"
  },
  {
    "type": "link",
    "to": "/llm-api/模型列表",
    "label": "模型列表"
  }
];
